import Medusa from '@medusajs/js-sdk';
import { transformMoneyFields } from '@sweethome/utils';
import { env } from './env';

const backendUrl = env.VITE_MEDUSA_BACKEND_URL;
const isAbsoluteUrl = /^https?:\/\//i.test(backendUrl);
const baseUrl = env.isDevelopment && isAbsoluteUrl ? '/' : backendUrl;

export const sdk = new Medusa({
  baseUrl,
  debug: env.isDevelopment,
  auth: {
    type: 'session',
  },
  ...(env.isDevelopment && isAbsoluteUrl ? { proxyUrl: backendUrl } : {}),
});

export const MEDUSA_BACKEND_URL = backendUrl;

export async function withAdminSdk<T>(callback: (sdk: Medusa) => Promise<T>): Promise<T> {
  const result = await callback(sdk);
  return transformMoneyFields(result) as T;
}
